<template>
    <v-main>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-dialog
        v-model="dialog"
        width="auto">
            <v-card>
                <v-card-title>
                    Informations
                </v-card-title>
                <v-card-text>
                {{msg_dialog}}
                </v-card-text>
            </v-card>
        </v-dialog>
        <NonAutorise v-show="!UtilisateurConnecte"/>
        <div v-show="UtilisateurConnecte">
             <v-row>
                <v-col cols="12">
                  <v-img
                    src="@/assets/FIRSILOGO.png"
                    contain
                    max-height="50"
                    max-width="150"
                    class="mr-2"
                  ></v-img>
                </v-col>
              </v-row>
            <v-alert
            type="info"
            color="secondary">
                Un seul dossier de bourse est accepté.
                <br>
                Vous pouvez Enregistrer les nouvelles modifications apportées à votre demande soit :
                <br>
                - Ouvrir votre dossier de bourse pour le compléter puis cliquer sur "Enregistrer". Vous pourrez revenir sur votre dossier pour le modifier.
                <br>
                - En cliquant sur "Valider" : vous validerez définitivement votre dossier et ne pourrez plus le modifier.
                <br>
                <br>
                Pour valider votre dossier, veillez à bien renseigner tous les champs et les pièces jointes obligatoires.
            </v-alert>
            <br>
            <v-btn 
            large
            color="secondary"
            @click="CreerDossier"
            v-show="!msg_erreur && creation">
            CREATION</v-btn>

            <v-data-table
            v-show="!msg_erreur"
            :headers="headers"
            :items="ListeDossier"
            class="elevation-1" 
            disable-pagination 
            hide-default-footer
            >
                <template v-slot:item={item}>
                    <tr v-if="!item.Supprimer">
                        <th class="text-xs-left">{{ item.anneeScolaireLang00 }}</th>
                        <th class="text-xs-left">{{ item.etatDuDossierLang00 }}</th>
                        <th>
                            <v-icon small class="mr-2" @click="ShowItem(item)">{{ icons.mdiEye }}</v-icon>
                        </th>
                        <th>
                            <v-btn 
                            x-large 
                            color="secondary" 
                            v-show="!item.readOnly" 
                            @click="SaveDossier(item)"
                            :disabled="!item.champsObligatoires || $storeDossierBourse.ListeAnnexesFirsi.filter(annexe=>{return annexe.ObligatoireSoumettre == true && !annexe.NomFichier}).length>0 || (item.etatDuDossier != $storeCatalogue.DataId.EtatDossierBrouillon && item.etatDuDossier != $storeCatalogue.DataId.EtatDossierEnAttenteComplement)">
                                Valider
                            </v-btn>
                        </th>
                    </tr>
                </template>
            </v-data-table>
            <div
            v-show="!msg_erreur && $storeDossierBourse.ListeAnnexesFirsi && $storeDossierBourse.ListeAnnexesFirsi.length > 0">
                <Annexes :creation="creation"/>
            </div>
            <v-alert
            border="top"
            color="primary"
            colored-border
            type="info"
            elevation="2"
            v-show="msg_erreur"
            >
            {{msg_erreur}}
            </v-alert>
        </div>
    </v-main>
</template>
<script>
import {
    mdiEye,
} from '@mdi/js'
import Annexes from "@/components/DossierBourse/ListeAnnexes"
import NonAutorise from "@/components/PageNonAutoriseExtranet"

export default {
    name:"ListeDb",
    components:{
        Annexes,
        NonAutorise,
    },
    data() {
        return{
            // Icon importés depuis mdi/js pour les icones d'édition/suppression
            icons: {
                mdiEye,
            },
            headers: [
                {text: 'Année scolaire', align: 'start', value: 'name', },
                { text: 'Etat du dossier', align: 'start', value: 'etat' },
                { text: '', align: 'start', value: 'action' },
                { text: '', align: 'start', value: 'valider' },
            ],
            ListeDossier:[],
            token:null,
            loader:false,
            msg_erreur:null,
            $storeDossierBourse:this.$storeDossierBourse,
            creation:false,
            UtilisateurConnecte:false,
            dialog:false,
            msg_dialog:null,
        }
    },
    methods:{
        CreerDossier(){
            window.location.href = "#/DossierBourse?t=" + this.token;
        },
        ShowItem(item){
            window.location.href = "#/DossierBourse?t=" + this.token + "&nid=" + item.idDossierBourse;
        },
        SaveDossier(item){
            var self = this;
            this.loader = true;
           Promise.all([
                this.$storeDossierBourse.ValiderDossier(this.token, item.idDossierBourse)
                    .then(response=>{
                        if(response){
                            if(response.status == 200 && !response.data.msg_erreur){
                                window.location.reload();
                            }
                            else{
                                this.msg_dialog = response.data.msg_erreur;
                                this.dialog=true;
                            }
                        }
                    })
                    .catch(error=>{
                        console.log(error)
                        this.loader = false;
                    })
            ])
            .then(function(){
                self.loader = false;
            })
        },
    },
    created(){
        document.title = "Liste dossier bourse";
    },
    mounted(){
        let token = this.$route.query.t;
        if(token){
            this.token = token.replace(/\s/g, "+");
            this.$storeDossierBourse.TokenExtranet = this.token;
        }
        var self = this;
        this.loader = true;
        Promise.all([
            this.$storeDossierBourse.GetListe(token)
            .then(response=>{
                if(response){
                    if(response.data.erreur){
                        this.msg_erreur = response.data.erreur;
                        this.UtilisateurConnecte = false;
                    }
                    else{
                        this.ListeDossier = response.data.liste;
                        this.creation = response.data.creer;
                        this.$storeDossierBourse.MapperAnnexeFirsiDto(response.data.listeAnnexesFirsi);
                        this.UtilisateurConnecte = true;
                    }
                }
            })
            .catch(error=>{
                console.log(error)
                this.loader = false;
            })
        ])
        .then(function(){
            self.loader = false;
        })
    },
}
</script>